module.exports = __webpack_public_path__ + "assets/img/6878-ai.svg";